// Libs
import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import moment from 'moment';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import ContractService from 'services/ContractService';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';
import PageHeader from 'components/common/PageHeader';
import ContractModal from 'components/admin/contract/ContractModal';

//-------------------------------------------------------------------------------------------------------------------

class ContractsPage extends React.Component {

    constructor(props) {
        super(props);

        this.contractModalRef = React.createRef();

        this.state = {
            isLoading: true,
            selectedIDs: {}
        };
    }
    
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.load();
    }

    async load() {
        GlobalStateService.setValues({
            area: 'contracts'
        });
        const contracts = await ContractService.list();
        const selectedIDs = {};
        contracts.forEach(a => {
            if (!a.dateSigned && (!a.instructor || (a.instructor.type != 'Candidate' && a.instructor.activeStatus != 'Deactivated'))) {
                selectedIDs[a.id] = true;
            }
        });
        this.setState({
            contracts,
            selectedIDs,
            isLoading: false
        });
    }

    toggle(id) {
        const selectedIDs = { ...this.state.selectedIDs };
        if (selectedIDs[id]) delete selectedIDs[id];
        else selectedIDs[id] = true;
        this.setState({ selectedIDs });
    }

    select(type) {
        const selectedIDs = {};

        let latestVersion = -1;
        this.state.contracts.forEach(a => {
            if (a.version > latestVersion) {
                latestVersion = a.version;
            }
        });

        this.state.contracts.forEach(a => {
            switch (type) {
                case 'all':
                    selectedIDs[a.id] = true;
                    break;
                case 'all-excl-deactivated':
                    if (!a.instructor || a.instructor.activeStatus != 'Deactivated') {
                        selectedIDs[a.id] = true;
                    }
                    break;
                case 'not-signed':
                    if (!a.dateSigned) {
                        selectedIDs[a.id] = true;
                    }
                    break;
                case 'not-signed-not-deactivated':
                    if (!a.dateSigned && (!a.instructor || a.instructor.activeStatus != 'Deactivated')) {
                        selectedIDs[a.id] = true;
                    }
                    break;
                case 'not-signed-over-21-days':
                    if (a.dateLinkSent && !a.dateSigned && (!a.instructor || a.instructor.activeStatus != 'Deactivated')) {
                        const numDaysAgo = moment().diff(a.dateLinkSent, 'days');
                        if (numDaysAgo >= 21) {
                            selectedIDs[a.id] = true;
                        }
                    }
                    break;
                case 'not-latest-version':
                    if (a.version < latestVersion) {
                        selectedIDs[a.id] = true;
                    }
                    break;
            }
        });
        this.setState({ selectedIDs });
    }

    async confirmSend(id) {
        const { isSending, selectedIDs } = this.state;
        if (isSending) return;
        const ids = (id ? [id] : Object.keys(selectedIDs));
        const confirm = await BootboxHelper.confirm('Send ' + ids.length + ' contract(s)?');
        if (confirm) {
            this.setState({ isSending: true });
            var { numSent } = await ContractService.sendLinks(ids);
            this.setState({ isSending: false });
            this.load();
            BootboxHelper.alert(numSent + ' email(s) sent')
        }
    }

    async exportExcel() {
        if (this.state.isExporting) return;
        await ContractService.listExcel();
    }

    async getAllSignedAsZip() {
        this.setState({ isExporting: true });
        window.location = '/api/contract/get-all-signed-zip';
        setTimeout(() => {
            this.setState({ isExporting: false });
        }, 5000);
    }

    async open(id) {
        await this.contractModalRef.current.show({
            id
        });
        this.load();
    }

    render() {
        const { isSending, selectedIDs, contracts, isExporting } = this.state;
        const loginInfo = GlobalStateService.getValue('loginInfo');

        let latestVersion = -1;
        if (contracts) {
            contracts.forEach(a => {
                if (a.version > latestVersion) {
                    latestVersion = a.version;
                }
            });
        }

        return (<>
            <div className="page contracts-page">

                <PageHeader>
                    <h1>Contracts</h1>

                    <div className="buttons">

                        <div className="dropdown me-3">
                            <button className="btn btn-primary dropdown-toggle" type="button" id="actions-menu" data-bs-toggle="dropdown" aria-expanded="false">
                                <span className="d-none d-sm-inline">Select...</span>
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="actions-menu">
                                <li>
                                    <a className="dropdown-item" href="#" onClick={e => { e.preventDefault(); this.select('all'); }}>
                                        All
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" href="#" onClick={e => { e.preventDefault(); this.select('all-excl-deactivated'); }}>
                                        All excluding deactivated
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" href="#" onClick={e => { e.preventDefault(); this.select('none'); }}>
                                        None
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" href="#" onClick={e => { e.preventDefault(); this.select('not-signed'); }}>
                                        Not signed
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" href="#" onClick={e => { e.preventDefault(); this.select('not-signed-not-deactivated'); }}>
                                        Not signed, not deactivated
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" href="#" onClick={e => { e.preventDefault(); this.select('not-signed-over-21-days'); }}>
                                        Not signed, sent 21+ days ago
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" href="#" onClick={e => { e.preventDefault(); this.select('not-latest-version'); }}>
                                        Not on latest version ({latestVersion})
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <button className="btn btn-primary" onClick={e => this.confirmSend()} disabled={isSending || Object.keys(selectedIDs).length == 0}>
                            {isSending ? <>
                                <Loader isInline />{' '}
                                Sending...
                            </> : <>
                                <span className="fa-solid fa-envelope"></span>{' '}
                                Send ({Object.keys(selectedIDs).length})
                            </>}
                        </button>

                        <div className="dropdown">
                            <button className="btn btn-primary dropdown-toggle ms-3" type="button" id="actions-menu" data-bs-toggle="dropdown" aria-expanded="false">
                                <span className="d-none d-sm-inline">
                                    {isExporting && <><Loader isInline />{' '}</>}
                                    Export...
                                </span>
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="actions-menu">
                                {loginInfo.site.enableExcelExport &&
                                    <li>
                                        <Link className="dropdown-item" to="#" onClick={e => {
                                            e.preventDefault();
                                            this.exportExcel();
                                        }}>
                                            Excel
                                        </Link>
                                    </li>
                                }
                                <li>
                                    <Link className="dropdown-item" to="#" onClick={e => {
                                        e.preventDefault();
                                        this.getAllSignedAsZip();
                                    }}>
                                        PDFs (latest signed)
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        
                    </div>
                    
                </PageHeader>

                <main>

                    <Container>
                        
                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>

            <ContractModal ref={this.contractModalRef} />

        </>);
    }

    renderInner() {
        const {
            isLoading,
            contracts,
            selectedIDs
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (

            <div className="sticky-table-container scrolling">

                <table className="table table-bordered sticky-table selectable contracts-table">
                    <thead>
                        <tr>
                            <th className="select-col"></th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Details</th>
                            <th>Active Status</th>
                            <th className="version-col">Version</th>
                            <th>Date sent</th>
                            <th>Date signed</th>
                            <th className="actions-col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {contracts.map(a =>
                            <tr key={a.id}>
                                <td className="select-col" onClick={() => this.toggle(a.id)}>
                                    <input
                                        type="checkbox"
                                        checked={!!selectedIDs[a.id]}
                                        onChange={() => null}
                                    />
                                </td>
                                <td onClick={() => this.toggle(a.id)}>
                                    {a.subAgency ? '(Sub-agency)' : a.instructor.firstName}
                                </td>
                                <td onClick={() => this.toggle(a.id)}>
                                    {a.subAgency ? a.subAgency.name : a.instructor.lastName}
                                </td>
                                <td onClick={() => this.toggle(a.id)}>
                                    <b>Email(s)</b><br />
                                    {a.emailAddresses.join('; ')}
                                    {a.emailAddresses.filter(e => !!e).length == 0 && <b>No email address</b>}

                                    {a.subAgency && <>
                                        <br/>
                                        <b>Instructor(s)</b><br />
                                        {a.subAgency.instructors.map(i =>
                                            <div key={i.id}>
                                                {i.firstName} {i.lastName} ({i.activeStatus})
                                            </div>
                                        )}
                                    </>}

                                </td>
                                <td onClick={() => this.toggle(a.id)}>
                                    {a.instructor ? a.instructor.activeStatus : ''}
                                </td>
                                <td className="version-col" onClick={() => this.toggle(a.id)}>
                                    {a.version}
                                </td>
                                <td onClick={() => this.toggle(a.id)}>
                                    {a.dateLinkSent && <>
                                        {moment(a.dateLinkSent).format('DD/MM/YYYY')}
                                        <br />({a.dateLinkSent ? moment().diff(a.dateLinkSent, 'days') : ''} day(s))
                                    </>}
                                </td>
                                <td onClick={() => this.toggle(a.id)}>{a.dateSigned ? moment(a.dateSigned).format('DD/MM/YYYY') : ''}</td>
                                <td className="actions-col">

                                    <button type="button" className="btn btn-primary w-100 btn-sm" onClick={() => this.open(a.id)}>
                                        View
                                    </button>

                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

            </div>

        );
    }
}

export default withRouter(ContractsPage);